import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Arrow } from '../../images/icons/fs-lc-arrow.svg';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import SmartLink from '../Common/SmartLink';
import * as styles from './ProfileCard.module.scss';
import ProfileImage from './ProfileImage';

const ProfileCard = (props) => {
  const { image, accentColor } = props;
  const bgColors = { Grey: styles.grey, Pink: styles.pink, None: styles.none, 'Clear (Dark BG)': styles.clearDark };

  return (
    <SmartLink
      to={props.link}
      style={{ display: 'block' }}
      data-analytics-component={'profile-card'}
      data-analytics-id={props.name}
      className={props.className}
    >
      <ProfileImage image={image} />
      <div className={[styles.content, bgColors[accentColor] || styles.pink].join(' ')}>
        <div>
          <b>{props.name}</b>
          <br />
          <RichTextConverter copy={props.copy} />
        </div>
        {props.link && <Arrow className={styles.arrow} />}
      </div>
    </SmartLink>
  );
};

ProfileCard.propTypes = {
  image: PropTypes.object.isRequired,
  copy: PropTypes.object.isRequired,
  link: PropTypes.string,
};

export default ProfileCard;
